import { BodyLight } from "@ui/fonts";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import clsx from "clsx";
import styles from "./new-employees-body-row.module.scss";
import {
  SingleTrainingRequestProgram,
  trainingRequestEducationForms,
} from "@interfaces/request-training";
import { useState } from "react";
import moment, { Moment } from "moment";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ruRU } from "@mui/x-date-pickers/locales";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useUnit } from "effector-react";
import { $UserAddPermissions, ACTIONS } from "@store/user-store";
import toast from "react-hot-toast";

type NewEmployeesBodyRowPropsT = {
  index: number;
  program: SingleTrainingRequestProgram;
  isEditable?: boolean;
  onEducationFormChange: (form: string) => void;
  onTrainingPeriodChange: (timestamp: Date) => void;
};

export const NewEmployeesBodyRow: React.FC<NewEmployeesBodyRowPropsT> = ({
  index,
  program,
  isEditable = true,
  onEducationFormChange,
  onTrainingPeriodChange,
}) => {
  const permissions = useUnit($UserAddPermissions);

  const [educationForm, setEducationForm] = useState(
    program.form == null ? "Очная" : program.form
  );
  const [isDateError, setIsDateError] = useState(false);

  // здесь стоит `any` потому что проп `onChange` в селекте ниже не принимает стандартный `React.ChangeEvent<HTMLInputElement>` а требует кастомный тип `ChangeEvent<{name?: string; value: unknown}>`
  const handleFormChange = (e: any) => {
    const value = e.target.value as string;

    setEducationForm(value);
    onEducationFormChange(value);
  };

  const handlePeriodDateChange = (date: Moment | null) => {
    setIsDateError(false);

    if (date?.isBefore(moment())) {
      toast.error("Нельзя выбрать прошедшую дату");
      setIsDateError(true);
      return;
    }

    if (date?.isValid()) {
      onTrainingPeriodChange(date.toDate());
    }
  };

  return (
    <TableRow>
      <TableCell align="left">
        <div className={clsx(styles.table_row_center)}>
          <BodyLight>{++index}</BodyLight>
        </div>
      </TableCell>
      <TableCell align="left">
        <div className={styles.edit_and_save}>
          <div
            className={clsx(styles.table_row_center, styles.table_row_title)}
          >
            <BodyLight>{program.programTitle.slice(0, 150)}</BodyLight>
          </div>
        </div>
      </TableCell>
      <TableCell align="left">
        <div className={styles.table_row_center}>
          {isEditable ? (
            <Select
              defaultValue={educationForm}
              onChange={handleFormChange}
              variant="standard"
              disabled={
                !permissions.hasPermission(
                  ACTIONS.companyApplicationsForTraining_allowedToEdit
                )
              }
            >
              {trainingRequestEducationForms.map((item) => (
                <MenuItem value={item.id}>{item.title}</MenuItem>
              ))}
            </Select>
          ) : (
            <BodyLight>{educationForm}</BodyLight>
          )}
        </div>
      </TableCell>
      <TableCell align="left">
        <div className={styles.table_row_center}>
          <BodyLight>{program.students.length}</BodyLight>
        </div>
      </TableCell>
      <TableCell align="left">
        <div className={styles.table_row_center}>
          {isEditable ? (
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale={"ru"}
              localeText={
                ruRU.components.MuiLocalizationProvider.defaultProps.localeText
              }
            >
              <DatePicker
                disabled={
                  !permissions.hasPermission(
                    ACTIONS.companyApplicationsForTraining_allowedToEdit
                  )
                }
                value={program.deadline ? moment(program.deadline) : null}
                onChange={handlePeriodDateChange}
                format="DD.MM.YYYY"
                autoFocus={false}
                minDate={moment()}
                slotProps={{
                  actionBar: { actions: ["cancel", "accept"] },
                  textField: {
                    variant: "standard",
                    error: isDateError,
                  },
                }}
                localeText={{
                  toolbarTitle: "",
                  cancelButtonLabel: "Отменить",
                  okButtonLabel: "ОК",
                }}
              />
            </LocalizationProvider>
          ) : (
            <BodyLight>
              {program.deadline &&
                moment(program.deadline).format("DD.MM.YYYY")}
            </BodyLight>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};
